import { render } from "./sIdentify.vue?vue&type=template&id=159b7d78"
import script from "./sIdentify.vue?vue&type=script&lang=js"
export * from "./sIdentify.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__